module.exports = __webpack_public_path__ + "static/media/img01.de6d9189.webp";